module.exports = __webpack_public_path__ + "img/The_Impact_of_Allyship.750c85ad.jpg";